import { AnyAction } from '@reduxjs/toolkit'

import {
  AUTHENTICATION_FAILURE,
  AUTHENTICATION_SIGNOUT,
  AUTHENTICATION_SUCCESS,
  EXPIRED_SESSION_FAILURE
} from './actionTypes'

const extractUserPoolId = (issuer: string) => {
  try {
    return new URL(issuer).pathname.replace('/', '')
  } catch {}
}

type AuthenticationHandlerState = {
  accessToken?: string
  email?: string
  expirationTime?: number
  idToken?: string
  isAuthenticated?: boolean
  isAuthenticationError?: boolean
  userPoolId?: string
}

export const initialState: AuthenticationHandlerState = {
  accessToken: undefined,
  email: undefined,
  expirationTime: undefined,
  idToken: undefined,
  isAuthenticated: undefined,
  isAuthenticationError: undefined,
  userPoolId: undefined
}

export default function authenticationReducer(state = initialState, action: AnyAction): AuthenticationHandlerState {
  switch (action.type) {
    case AUTHENTICATION_SUCCESS: {
      const accessToken = action.session.getAccessToken()
      const idToken = action.session.getIdToken()
      const idTokenPayload = idToken.decodePayload()

      return {
        ...initialState,
        accessToken: accessToken.getJwtToken(),
        email: idTokenPayload.email,
        expirationTime: accessToken.getExpiration(),
        idToken: idToken.getJwtToken(),
        isAuthenticated: true,
        userPoolId: extractUserPoolId(idTokenPayload.iss)
      }
    }

    case AUTHENTICATION_FAILURE: {
      return { ...initialState, isAuthenticationError: true }
    }

    case AUTHENTICATION_SIGNOUT: {
      return { ...initialState }
    }

    case EXPIRED_SESSION_FAILURE: {
      // set the expiration to now thereby forcing the user to refresh their session
      return { ...state, expirationTime: Math.floor(Date.now() / 1000) }
    }

    default: {
      return state
    }
  }
}
